(function() {
  'use strict';

  angular
    .module('admin.users.details.collections.sets.prints', [])
    .controller('CollectionsSetsPrintsAdminCtrl', CollectionsSetsPrintsAdminCtrl);

  /** @ngInject */
  function CollectionsSetsPrintsAdminCtrl($stateParams, CollectionsAdminService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.setId = $stateParams.setId;
    vm.channelId = $stateParams.channelId;
    vm.username = $stateParams.username;
    vm.channels = [];

    function reloadPagination() {
      vm.perPage = 25;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();


    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }


      CollectionsAdminService.listPrintsForSet(vm.oldPage, 25, $stateParams.parentId, vm.setId).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].username = vm.username;
        }
        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };
  }

})();
